import * as React from 'react';
import { translate } from 'components/translate-hoc';

// constants
import { TEXT_KEYS } from './legal-tagline.constants';

// types
import { IGenericFunction } from 'types/generics';
import { ITranslationProps } from 'types/translation';

import './legal-tagline.styles.less';

interface ILegalTaglineProps extends ITranslationProps {
    value: boolean;
    onChange: IGenericFunction<void, React.ChangeEvent<HTMLInputElement>>;
}

export const LegalTagline: React.SFC<ILegalTaglineProps> = props => {
    const { dangerouslyTranslateWithHTML: translateKey } = props;

    const text = translateKey(TEXT_KEYS.LEGAL_TAGLINE);

    return (
        <div className="sitegen-legal-tagline">
            <input
                type="checkbox"
                // @ts-ignore
                value={props.value}
                onChange={props.onChange}
                className="sitegen-legal-tagline__input"
            />
            <div className="sitegen-legal-tagline__text">{text}</div>
        </div>
    );
};

export default translate()(LegalTagline);
